import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const HromadnaKorespondence = {
	name: NAME,
	apiProvider,
	router,
};
